import { gql, useQuery } from '@apollo/client'

import {
  CurrentUserFragmentDoc,
  ManagementQuery,
  ManagementQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<ManagementQuery, ManagementQueryVariables>(QUERY)

  return {
    state: {
      hasUnappliedDeliveryItems: !!data?.user?.hasUnappliedDeliveryItems,
      hasWaitingPaymentItems: !!data?.user?.hasWaitingPaymentItems,
      hasWaitingResaleRafflePaymentItems:
        !!data?.user?.hasWaitingResaleRafflePaymentItems,
      isMembershipPersonalInformationRequired:
        !!data?.user?.isMembershipPersonalInformationRequired,
    },
    actions: {},
  }
})

const QUERY = gql`
  query Management {
    user {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`
